// extracted by mini-css-extract-plugin
export var bannerContainer = "online-stores-banner-module--bannerContainer--d6d3a";
export var bannerContent = "online-stores-banner-module--bannerContent--c7312";